import { useState } from "react";
import StationBoard from "./StationBoard";
import { ChefHat, Wine } from "lucide-react";

export default function StationsPage() {
  const [station, setStation] = useState(() => localStorage.getItem("stationView") || "kitchen");
  const pick = (s) => { setStation(s); localStorage.setItem("stationView", s); };
  const Btn = ({ id, label, Icon }) => (
    <button data-testid={`station-tab-${id}`} onClick={() => pick(id)}
      className={`flex h-10 flex-1 items-center justify-center gap-2 rounded-xl text-sm font-bold transition-colors sm:flex-none sm:px-6 ${station === id ? "bg-slate-900 text-white" : "bg-white text-slate-600 ring-1 ring-sand-300"}`}>
      <Icon size={16} /> {label}
    </button>
  );
  return (
    <div>
      <div className="mx-auto flex max-w-6xl gap-2 px-4 pt-4">
        <Btn id="kitchen" label="Kitchen" Icon={ChefHat} />
        <Btn id="bar" label="Bar" Icon={Wine} />
      </div>
      <StationBoard key={station} station={station}
        title={station === "kitchen" ? "Kitchen" : "Bar"} Icon={station === "kitchen" ? ChefHat : Wine} />
    </div>
  );
}
